<template>
    <div class="card h-100 rounded-0 border-0" :class="animation">
        <div class="card-body text-center h-100 p-0 p-sm-0">
            <div class="row">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row">
                <div class="form-wrap-step">
                    <div class="form-header">
                        <h5 class="title__normal">ゴミの量を選択してください。</h5>
                    </div>
                </div>
            </div>
            <div class="form-wrap-step">
                <div class="row" style="margin-bottom: 0.8rem;">
                    <div class="col-md-12 text-center below-adv-btn"> 
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg mb-3 rounded-1" @click="handleClick(AMOUNT_OVERSIZED_1)">
                            <span class="text">単品</span>
                        </button>
                    </div>
                    <div class="col-md-12 flex below-adv-btn justify-content-center">
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg mb-3 rounded-1" @click="handleClick(AMOUNT_OVERSIZED_2)">
                            <span class="text">軽トラック</span>
                        </button>
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg mb-3 rounded-1" @click="handleClick(AMOUNT_OVERSIZED_3)">
                            <span class="text">1tトラック</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackButton from '../BackButton.vue';

    export default {
        name: 'AmountGarbage',
        props: {
            animation: {
                default: ''
            },
        },
        data() {
            return {
                AMOUNT_OVERSIZED_1: 1,
                AMOUNT_OVERSIZED_2: 2,
                AMOUNT_OVERSIZED_3: 3,
            };
        },
        methods: {
            handleClick(amount) {
                const currentStep = 2;
                const followStep = 1;
                this.$emit("handleChangeStep", currentStep, followStep);
                this.$emit("setAmountOfGarbage", {
                    label: 'trashOversized',
                    data: {
                        amountOfGarbage: amount
                    }
                });
            },
            handleBackToStep() {
                const currentStep = 2;
                const followStep = 0;
                this.$emit("handleChangeStep", currentStep, followStep);
            }
        },
        components: { 
            BackButton 
        }
    }
</script>